<template>
 
<div ref="baloon" class="baloon" :class='{"right-align" : item.origin=="me", "fade-in" :fadeIn}'>
    <div class="content-area">
      {{item.message}}
      <div class="date">{{getChatDate(item.datetime)}}</div>
    </div>
    
</div>
</template>

<script>
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';

export default {
  name: 'chat-baloon',
  props:{
    item:{default:{
      name:"",
      datetime:"",
      origin:""}},
    //person_id:{default:0},
  },
  data:function(){
    return {
      fadeIn:false,
    }
  },
  computed:{
    ...mapState([]),
    
  },
  methods:{
    getChatDate(dateString){
      return helper.convertChatDate(dateString);
    },
    /*
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    }
    */
  },
  mounted:function(){
    setTimeout(()=>{
       this.fadeIn=true;
    },1)
   
  },
  components:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.baloon{
  transform-origin: 50% 50%;
  display:relative;
  width:100%;
  margin-bottom:20px;
  display:flex;
  align-content:flex-end;
  opacity:0;
  transition:all .35s ease-in-out;
  white-space: pre-line;
}
.fade-in{
  opacity:1;
}
.content-area::after{
  content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    left: 10%;
    bottom: -5px;
    transform: rotateZ(45deg);
    z-index:-1;
    background-color: inherit;
}
.right-align{
  justify-content: flex-end;
}
.content-area{
  position:relative;
  border-radius:4px;
  min-width:200px;
  max-width:85%;
  padding:15px 10px;
  background-color:#ecffd1!important;
  overflow-wrap: break-word;
}

.right-align .content-area{
  background-color:#d2f2ff!important;
}

.right-align .content-area::after{
    left:90%;
}
.date{
  font-size:.7em;
  position:absolute;
  bottom:2px;
  right:4px;
  color:rgba(0,0,0,.35);
}
.name{
  font-size:.6em;
  position:absolute;
  top:2px;
  left:10px;
  color:rgba(0,0,0,.35);
}

</style>
